import * as THREE from 'three';
import * as GEM from '../../../trillion-viewer/src/viewer/gemsConfigs';
import { getMaterialForGem, IGem, isGemIncludedInJewelry } from './IGem';

export async function applyGems(scene: THREE.Group, gems: IGem[]) {
  for (const e of scene.children) {
    const mesh = e as THREE.Mesh;
    if (mesh instanceof THREE.Mesh && mesh.material instanceof THREE.MeshStandardMaterial) {
      for (const gem of gems) {
        if (isGemIncludedInJewelry(gem, mesh)) {
          mesh.material = await getMaterialForGem(gem, mesh);
          break;
        }
      }
    }
  }
}
